<template>
  <content-loader
    viewBox="0 0 650 22"
    :speed="1"
    primaryColor="#ab0303"
    secondaryColor="#bc0303"
  >
    <rect x="0" y="6" rx="0" ry="0" width="75" height="16" />
  </content-loader>
  <content-loader
    viewBox="0 0 650 70"
    :speed="1"
    primaryColor="#f3f3f3"
    secondaryColor="#cfcfcf"
  >
    <rect x="0" y="4" rx="0" ry="0" width="650" height="30" />
    <rect x="0" y="36" rx="0" ry="0" width="650" height="30" />
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
export default {
  components: {
    ContentLoader,
  },
};
</script>